import { Link } from "react-router-dom";
import MarketingShell from "@/components/marketing/MarketingShell";
import { useSeo } from "@/lib/seo";

const LINKS = [["Course Catalog", "/courses"], ["Academic Resources", "/resources"], ["Start Here", "/#start-here"], ["Contact", "/contact"]];

export default function NotFound() {
  useSeo({ title: "Page Not Found | Infant Sleep Consultant Near Me", noindex: true });
  return (
    <MarketingShell>
      <div className="max-w-3xl mx-auto px-5 py-32 text-center" data-testid="not-found-page">
        <div className="eyebrow text-[#BDA677] mb-4">Error 404</div>
        <h1 className="font-display text-4xl sm:text-5xl text-[#F7F5F0]">Page not found</h1>
        <p className="mt-5 text-[#A39E98]">The page you were looking for has moved or no longer exists. These pages can help you continue.</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          {LINKS.map(([l, to]) => <a key={to} href={to} data-testid={`not-found-link-${l.toLowerCase().replace(/\s+/g, "-")}`} className="border border-[#2E2C2A] rounded-full px-5 py-2.5 text-sm text-[#F7F5F0] hover:border-[#C2836B]/60 transition-colors">{l}</a>)}
        </div>
      </div>
    </MarketingShell>
  );
}
